// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'lock-closed';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M13.781 7.406H4.22c-.587 0-1.063.476-1.063 1.063v7.437c0 .587.476 1.063 1.063 1.063h9.562c.587 0 1.063-.476 1.063-1.063V8.47c0-.587-.476-1.063-1.063-1.063Z' />
    <path d='M5.281 7.406V4.75a3.719 3.719 0 1 1 7.438 0v2.656M9 12.188a.266.266 0 1 1 0-.532m0 .532a.266.266 0 1 0 0-.532' />
  </g>
);

export const viewBox = '0 0 18 18';
